export default ({ onSubmit, children }) => (
  <form className="container has-text-centered" onSubmit={onSubmit}>
    <div>{children}</div>
  </form>
);
